import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ChartSwitches } from 'interfaces/store/chartFilters';

const initialState: ChartSwitches = {
  xAxisSwitch: true,
  timeDurationSwitch: true,
  quartileMedianSwitch: false
};

const chartSwitchesSlice = createSlice({
  name: 'chartSwitches',
  initialState,
  reducers: {
    toggleXAxisSwitch(state) {
      state.xAxisSwitch = !state.xAxisSwitch;
    },
    toggleTimeDurationSwitch(state) {
      state.timeDurationSwitch = !state.timeDurationSwitch;
    },
    toggleQuartileMedianSwitch(state) {
      state.quartileMedianSwitch = !state.quartileMedianSwitch;
    },
    handleXAxisSwitch(state, action: PayloadAction<boolean>) {
      state.xAxisSwitch = action.payload;
    },
    handleTimeDurationSwitch(state, action: PayloadAction<boolean>) {
      state.timeDurationSwitch = action.payload;
    },
    handleQuartileMedianSwitch(state, action: PayloadAction<boolean>) {
      state.quartileMedianSwitch = action.payload;
    },
    resetSwitches(state) {
      state.xAxisSwitch = true;
      state.timeDurationSwitch = true;
      state.quartileMedianSwitch = false;
    }
  }
});

export const {
  resetSwitches,
  toggleXAxisSwitch,
  toggleTimeDurationSwitch,
  toggleQuartileMedianSwitch,
  handleXAxisSwitch,
  handleTimeDurationSwitch,
  handleQuartileMedianSwitch
} = chartSwitchesSlice.actions;

export default chartSwitchesSlice.reducer;
